// Visibility window for the "Nei er sagt!" (notReady) panic button in the shot
// trainer remote command bar. Pure function — no stores, no JSX.
//
// The button belongs ONLY between the Lading command and the Ild call — that is
// the window where a shooter may shout "Nei!". Two knowledge levels exist:
//
// - Device running the trainer (shootingInProgress ticks in shotTrainerStore):
//   exact window = any pre-Ild countdown running (loadingTime → Lading,
//   readyTime → "Er skytterne klare" / the 15s not-ready wait, fireTime →
//   "Klar"). Once Ild plays only shootingTime ticks, so the window closes.
// - Pure phone remote (no local sequence state — there is no feedback channel
//   from the receiver): approximate with ladingActive, tracked by the command
//   bar from the moment "2. Lading" is sent until any other command is sent.
export function isNeiWindowOpen({ shootingInProgress, loadingTime, readyTime, fireTime, ladingActive }) {
    if (shootingInProgress) {
        return loadingTime > 0 || readyTime > 0 || fireTime > 0;
    }
    return !!ladingActive;
}
